import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=d97d4784"
import script from "./ImageGallery.vue?vue&type=script&lang=ts"
export * from "./ImageGallery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports